const scaleArray = (scale) => (items) => items.map((value) => scale * value);

export default scaleArray;
